import { render, staticRenderFns } from "./webFirst.vue?vue&type=template&id=c22c8bd8&scoped=true"
import script from "./webFirst.vue?vue&type=script&lang=js"
export * from "./webFirst.vue?vue&type=script&lang=js"
import style0 from "./webFirst.vue?vue&type=style&index=0&id=c22c8bd8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_bbcd016e015477a3ecf09e87b6c3f580/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22c8bd8",
  null
  
)

export default component.exports